import { TIME } from "@bridgesplit/utils";

import { FONT_SIZES } from "../../theme";
import { TimeDomainPeriod } from "./types";

export const CHART_AREA_FILL_OPACITY = 0.2;
export const DEFAULT_CHART_HEIGHT = 300;
export const DEFAULT_CHART_MARGIN = { top: FONT_SIZES.caption / 2, bottom: 0, right: 0, left: 0 };

export const CHART_SPACING = 2;
export const CHART_HEADER_OFFSET = 24;

export const DEFAULT_EXTREMA = { min: 0, max: 100 };

export const PROJECTION_DOT = {
    cell: 4,
    radius: 1
};

export const DEFAULT_TIME_DOMAIN_PERIODS: TimeDomainPeriod[] = [
    { label: "1D", seconds: TIME.DAY },
    { label: "1W", seconds: TIME.WEEK },
    { label: "1M", seconds: TIME.MONTH }
];

export const MIN_TIME_TICKS = 5;
export const MAX_TIME_TICKS = 8;

export const TIME_TICK_STEPS: number[] = [
    TIME.HOUR,
    TIME.HOUR * 3,
    TIME.HOUR * 6,
    TIME.HOUR * 12,
    TIME.DAY,
    TIME.DAY * 2,
    TIME.DAY * 3,
    TIME.WEEK,
    TIME.WEEK * 2,
    TIME.DAY * 30,
    TIME.DAY * 60,
    TIME.DAY * 90,
    TIME.DAY * 180,
    TIME.DAY * 365
];
